import React from 'react';
import { OpsHeaderWrapper } from './style';

/**
 * AXON-3585: the Ops section header.
 *
 * Rendered by all three Ops pages — the clinic table, a single clinic, and a
 * weekday grid — so the section is named wherever you land in it, including on
 * a URL somebody pasted. Each page's own heading or breadcrumb follows beneath
 * it and says which depth you are at.
 */
export const OpsHeader: React.FC<{}> = () => (
  <OpsHeaderWrapper>
    <div className="ops-header-inner">
      <h1>Operations</h1>
      <p className="ops-header-subtitle">Recurring capacity by clinic.</p>
    </div>
  </OpsHeaderWrapper>
);

export default OpsHeader;
